import { render, staticRenderFns } from "./PreloaderCount.vue?vue&type=template&id=81ddb2f2&lang=pug&"
import script from "./PreloaderCount.vue?vue&type=script&lang=js&"
export * from "./PreloaderCount.vue?vue&type=script&lang=js&"
import style0 from "./PreloaderCount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports